import { makeAutoObservable, runInAction } from 'mobx';
import { toast } from 'react-toastify';
import { productCalculationServices } from 'services/CalculationServices/productCalsServices';

export class ProductCalculationsStore {
  productCalculation: any = null;
  roomProductCalculations: any[] = [];
  dateProductCalculations: any = {};
  isLoading: boolean = false;

  constructor() {
    makeAutoObservable(this);
  }

  fetchProductCalculation = async (jobId: string) => {
    this.isLoading = true;
    try {
      const response = await productCalculationServices.getProductCalculationForJob(jobId);

      runInAction(() => {
        if (response.success) {
          this.productCalculation = response.data;
        } else {
          this.productCalculation = null;
          toast.error('Failed to fetch product calculation');
        }
      });
    } catch (error) {
      runInAction(() => {
        this.productCalculation = null;
        toast.error('Error fetching product calculation');
      });
    } finally {
      runInAction(() => {
        this.isLoading = false;
      });
    }
  };

  fetchRoomProductCalculations = async (room: string, date?: string) => {
    this.isLoading = true;
    try {
      const response = await productCalculationServices.getProductCalculationsForRoom(room, date);

      runInAction(() => {
        if (response.success) {
          this.roomProductCalculations = response.data;
        } else {
          this.roomProductCalculations = [];
          toast.error('Failed to fetch room product calculations');
        }
      });
    } catch (error) {
      runInAction(() => {
        this.roomProductCalculations = [];
        toast.error('Error fetching room product calculations');
      });
    } finally {
      runInAction(() => {
        this.isLoading = false;
      });
    }
  };

  fetchDateProductCalculations = async (date: string) => {
    this.isLoading = true;
    try {
      const response = await productCalculationServices.getProductCalculationsForDate(date);

      runInAction(() => {
        if (response.success) {
          this.dateProductCalculations = response.data;
        } else {
          this.dateProductCalculations = {};
          toast.error('Failed to fetch date product calculations');
        }
      });
    } catch (error) {
      runInAction(() => {
        this.dateProductCalculations = {};
        toast.error('Error fetching date product calculations');
      });
    } finally {
      runInAction(() => {
        this.isLoading = false;
      });
    }
  };

  updateProductCalculation = async (jobId: string, data: any) => {
    this.isLoading = true;
    try {
      const response = await productCalculationServices.updateProductCalculation(jobId, data);

      runInAction(() => {
        if (response.success) {
          this.productCalculation = response.data;
          toast.success('Product calculation updated successfully');
        } else {
          toast.error('Failed to update product calculation');
        }
      });
    } catch (error) {
      runInAction(() => {
        toast.error('Error updating product calculation');
      });
    } finally {
      runInAction(() => {
        this.isLoading = false;
      });
    }
  };

  // Reset store data
  reset = () => {
    this.productCalculation = null;
    this.roomProductCalculations = [];
    this.dateProductCalculations = {};
    this.isLoading = false;
  };
}
